import axios from "axios";
import { API_CONFIGURACION } from "config/general/Configuracion";
import { HEADERS, apiTimeout } from "config/general/Configuracion";


const TerminosYCondicionesApiHelper = {
  
    obtenerTerminosYCondiciones: async (id) => {
        try {
            const url = `${API_CONFIGURACION}/v1/configuracion/get_tiquete/${id}`;
            const response = await axios.get(url, {
                headers: HEADERS(),
                timeout: apiTimeout
            });
            return response.data;
        } catch (error) {
            console.error("Error al obtener los términos y condiciones:", error);
            throw error;
        }
    },
};

export default TerminosYCondicionesApiHelper;